import React from 'react';
import { useNavigation } from '../../contexts/NavigationContext';
import useMediaQuery from '../../hooks/useMediaQuery';

/**
 * MainContent - Responsive main content wrapper
 * Handles proper spacing and centering based on sidebar state
 */
export default function MainContent({ children }) {
  const { sidebarCollapsed } = useNavigation();
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  // Calculate sidebar offset dynamically
  const sidebarOffset = isDesktop ? (sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64') : '';

  return (
    <main className={`flex-grow text-sm pb-16 lg:pb-0 transition-all duration-300 ${sidebarOffset}`}>
      {children}
    </main>
  );
}
